import React from 'react';
import styled from 'styled-components';
import { ReactComponent as WarningSVG } from '@Assets/Svgs/ic_warning.svg';
import TX from '@Components/Common/Text';
import themes from '@Styles/Themes';
import PropTypes from 'prop-types';

const HoverComponent = ({ label, style, absolute, iconColor, iconOpacity, align }) => {
  const resultIconColor = iconColor || themes.light.colors.ui_4;
  const resultIconOpacity = iconOpacity || '1';
  return (
    <ExplainContainer style={style} absolute={absolute}>
      <ExplainHover fill={resultIconColor} opacity={resultIconOpacity} />
      <HoverWrapper align={align}>
        <HoverText>{label}</HoverText>
      </HoverWrapper>
    </ExplainContainer>
  );
};

HoverComponent.propTypes = {
  label: PropTypes.string.isRequired,
  align: PropTypes.oneOf(['left', 'center', 'right']),
};

HoverComponent.defaultProps = {
  align: 'center',
};

const ExplainContainer = styled.div`
  position: ${({ absolute }) => (absolute ? 'absolute' : 'relative')};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ExplainHover = styled(WarningSVG)`
  fill: ${({ fill }) => fill} !important;
  opacity: ${({ opacity }) => opacity} !important;
  width: 16px;
  height: 16px;
  & path {
    fill: ${({ fill }) => fill} !important;
    opacity: ${({ opacity }) => opacity} !important;
  }
`;

const HoverWrapper = styled.div`
  position: relative;

  left: ${({ align }) => (align === 'left' ? '0' : 'auto')};
  right: ${({ align }) => (align === 'right' ? '0' : 'auto')};

  bottom: 28px;
  display: none;
  border-radius: 4px;
  background: var(--ui_on_2, #383839);
  box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.4);
  position: absolute;
  width: 220px;
  padding: 6px;

  ${ExplainContainer}:hover & {
    display: block;
  }
`;

const HoverText = styled(TX.FootnoteM)`
  display: flex;

  color: var(--ui_1, #fcfcfd);
  text-align: center;
  font-feature-settings: 'clig' off, 'liga' off;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px; /* 123.077% */
  letter-spacing: -0.3px;
  word-break: keep-all;
`;

export default HoverComponent;
